export enum TimeOffStatus  {
    Unknown = 0,
    Pending = 10,
    Accepted = 20,
    Declined = 30,
}
